import styles from '@/styles/global/chat.module.scss'
import type { ReviewSummary } from '@/types/product'

export default function Chart({ reviewCount, reviewSummary }: { reviewCount: number, reviewSummary: ReviewSummary}) {

  function calculateParcent(num: number) {
    const value = Math.round(num / reviewCount * 10000) / 100 || 0
    const parcent = value > 100 ? "100%" : (value + "%")
    return parcent
  }

  return (
    <div className={styles['chart']}>
      {
        [5, 4, 3, 2, 1].map((index: number) => {
          const num = reviewSummary[`rating${index}` as keyof ReviewSummary] || 0
          const parcent = calculateParcent(num)
          return (
            <div className={styles['reviews-item']} key={index}>
              <span className={styles['rate']}>{index} Star: </span>
              <div className={styles['line']}>
                <div className={styles['value']} style={{ width: parcent }}></div>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}